import type { ReactNode } from 'react';
import styles from './SearchTray.module.css';
import { highlightMatch } from '../../lib/search/highlight';

export interface SearchResultRowProps {
  /** Already-highlighted title content, or plain text. */
  title: string;
  /** Small breadcrumb shown below the title (section › category, etc.). */
  breadcrumb?: string | null;
  /** Icon node — a file/folder/section SVG. */
  icon: ReactNode;
  /** Current query for inline match highlighting. */
  query: string;
  /** Whether the row is currently keyboard-highlighted (data-highlighted). */
  highlighted: boolean;
  onClick: () => void;
  /** Called when the mouse enters the row — used to drive the sliding
      highlight from hover (mirrors the megamenu's hover→active idiom). */
  onHover?: () => void;
  /** Optional ref-callback so the parent can scroll the row into view. */
  innerRef?: (el: HTMLButtonElement | null) => void;
}

export function SearchResultRow({
  title,
  breadcrumb,
  icon,
  query,
  highlighted,
  onClick,
  onHover,
  innerRef,
}: SearchResultRowProps) {
  return (
    <button
      type="button"
      ref={innerRef}
      role="option"
      aria-selected={highlighted}
      data-highlighted={highlighted}
      onClick={onClick}
      onMouseEnter={onHover}
      className={styles.row}
    >
      <span className={styles.rowIcon} aria-hidden="true">
        {icon}
      </span>
      <span className={styles.rowBody}>
        {breadcrumb && <span className={styles.rowBreadcrumb}>{breadcrumb}</span>}
        <span className={styles.rowTitle}>{highlightMatch(title, query)}</span>
      </span>
    </button>
  );
}
